import { useState } from 'react';

const usePhotoSwipe = props => {
  const {
    setPhotoSwipeItem
  } = props;

  const [photoSwipeItems, setPhotoSwipeItems] = useState([]);

  return {
    photoSwipeItems,
    setPhotoSwipeItems: rowData => {
      let items = [];
      if (setPhotoSwipeItem) {
        for (let row of rowData) {
          let item = setPhotoSwipeItem(row);
          if (item && item.id) {
            items.push(item);
          }
        }
      }
      setPhotoSwipeItems(items);
    }
  }
}

export default usePhotoSwipe;
